import { useState, useEffect } from 'react';
import API, { SERVER_URL } from '../../api/axios';
import AppLayout from '../../components/layout/AppLayout';
import { S } from '../../components/pageStyles';
import { Loader, StatCard, Tabs } from '../../components/ui';
import { LuBan, LuBanknote, LuCircleCheck, LuClipboardList, LuCreditCard, LuEye, LuGift, LuPackage, LuReceipt, LuShoppingCart, LuSmartphone, LuStore, LuTrash2, LuWallet } from 'react-icons/lu';

import { fmtF } from '../../theme';
const MODES_PAIEMENT = {
  especes: { label: 'Espèces', icon: <LuBanknote aria-hidden /> },
  mobile_money: { label: 'Mobile Money', icon: <LuSmartphone aria-hidden /> },
  credit: { label: 'Crédit', icon: <LuClipboardList aria-hidden /> },
};

export default function VentesProprietaire() {
  const [etablissements, setEtablissements] = useState([]);
  const [etabSelectionne, setEtabSelectionne] = useState(null);
  const [vue, setVue] = useState('historique'); // 'historique' | 'caisse'
  const [ventes, setVentes] = useState([]);
  const [produits, setProduits] = useState([]);
  const [kits, setKits] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [recherche, setRecherche] = useState('');
  const [rechercheArticle, setRechercheArticle] = useState('');
  const [filtreStatut, setFiltreStatut] = useState('tous');
  const [filtrePeriode, setFiltrePeriode] = useState('mois');
  const [venteDetail, setVenteDetail] = useState(null);
  const [message, setMessage] = useState('');
  const [panier, setPanier] = useState([]);
  const [modePaiement, setModePaiement] = useState('especes');
  const [note, setNote] = useState('');
  const [ongletCaisse, setOngletCaisse] = useState('produits');
  const [chargementVente, setChargementVente] = useState(false);

  const chargerDonnees = async () => {
    try {
      const etabRes = await API.get('/etablissements');
      const etabs = etabRes.data.etablissements || [];
      setEtablissements(etabs);
      if (etabs.length > 0) {
        setEtabSelectionne(etabs[0].id);
        await Promise.all([
          chargerVentes(etabs[0].id),
          chargerProduits(etabs[0].id),
          chargerKits(etabs[0].id),
        ]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setChargement(false);
    }
  };

  const chargerVentes = async (etabId) => {
    try {
      const param = etabId ? '?etablissement_id=' + etabId : '';
      const res = await API.get('/ventes' + param);
      setVentes(res.data.ventes || []);
    } catch (err) { console.error(err); }
  };

  const chargerProduits = async (etabId) => {
    try {
      const res = await API.get('/produits?etablissement_id=' + etabId);
      setProduits(res.data.produits || []);
    } catch (err) { console.error(err); }
  };

  const chargerKits = async (etabId) => {
    try {
      const res = await API.get('/kits?etablissement_id=' + etabId);
      setKits(res.data.kits || []);
    } catch (err) { console.error(err); }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { chargerDonnees(); }, []);

  const handleSelectEtab = async (etabId) => {
    setEtabSelectionne(etabId);
    setPanier([]);
    await Promise.all([
      chargerVentes(etabId),
      chargerProduits(etabId),
      chargerKits(etabId),
    ]);
  };

  // ── CAISSE ──
  const ajouterAuPanier = (article, type) => {
    const existant = panier.find(p => p.id === article.id && p.type === type);
    if (existant) {
      setPanier(panier.map(p =>
        p.id === article.id && p.type === type
          ? { ...p, quantite: p.quantite + 1 }
          : p
      ));
    } else {
      setPanier([...panier, {
        id: article.id,
        type,
        nom: article.nom,
        prix: parseFloat(article.prix || article.prix_kit),
        quantite: 1,
        unite: article.unite || 'Unité',
        stock: article.quantite
      }]);
    }
  };

  const modifierQte = (id, type, delta) => {
    setPanier(panier.map(p => {
      if (p.id === id && p.type === type) {
        const nouvelleQte = p.quantite + delta;
        if (nouvelleQte <= 0) return null;
        return { ...p, quantite: nouvelleQte };
      }
      return p;
    }).filter(Boolean));
  };

  const retirerDuPanier = (id, type) => {
    setPanier(panier.filter(p => !(p.id === id && p.type === type)));
  };

  const totalPanier = panier.reduce((t, p) => t + p.prix * p.quantite, 0);

const validerVente = async () => {
  if (panier.length === 0) {
    setMessage('❌ Ajoutez au moins un produit ou kit');
    return;
  }
  setChargementVente(true);
  try {
    const produits = panier
      .filter(p => p.type === 'produit')
      .map(p => ({ produit_id: p.id, quantite: p.quantite }));

    const kits = panier
      .filter(p => p.type === 'kit')
      .map(p => ({ kit_id: p.id, quantite: p.quantite }));

    await API.post('/ventes', {
      etablissement_id: etabSelectionne,
      mode_paiement: modePaiement,
      produits,
      kits,
      note
    });

    setMessage('✅ Vente enregistrée avec succès !');
    setPanier([]);
    setNote('');
    setModePaiement('especes');
    chargerVentes(etabSelectionne);
    chargerProduits(etabSelectionne);
    setVue('historique');
    setTimeout(() => setMessage(''), 3000);
  } catch (err) {
    setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
  } finally {
    setChargementVente(false);
  }
};

  const handleAnnuler = async (vente) => {
    const motif = window.prompt('Motif d\'annulation :');
    if (!motif) return;
    try {
      await API.patch('/ventes/' + vente.id + '/annuler', { motif_annulation: motif });
      setMessage('✅ Vente annulée !');
      chargerVentes(etabSelectionne);
      setVenteDetail(null);
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('❌ ' + (err.response?.data?.message || 'Erreur'));
    }
  };

  // Filtrage historique
  const maintenant = new Date();
  const ventesFiltrees = ventes.filter(v => {
    const matchRecherche = (v.numero_facture || '').toLowerCase().includes(recherche.toLowerCase()) ||
      (v.serveur_prenom + ' ' + v.serveur_nom).toLowerCase().includes(recherche.toLowerCase());
    const matchStatut = filtreStatut === 'tous' || v.statut === filtreStatut;
    const dateVente = new Date(v.created_at);
    let matchPeriode = true;
    if (filtrePeriode === 'jour') matchPeriode = dateVente.toDateString() === maintenant.toDateString();
    else if (filtrePeriode === 'semaine') { const d = new Date(maintenant); d.setDate(d.getDate() - 7); matchPeriode = dateVente >= d; }
    else if (filtrePeriode === 'mois') matchPeriode = dateVente.getMonth() === maintenant.getMonth() && dateVente.getFullYear() === maintenant.getFullYear();
    return matchRecherche && matchStatut && matchPeriode;
  });

  const totalCA = ventesFiltrees.filter(v => v.statut === 'validee').reduce((t, v) => t + parseFloat(v.montant_total || 0), 0);

  const articlesFiltres = ongletCaisse === 'produits'
    ? produits.filter(p => p.nom.toLowerCase().includes(rechercheArticle.toLowerCase()) && p.quantite > 0)
    : kits.filter(k => k.nom.toLowerCase().includes(rechercheArticle.toLowerCase()) && k.actif);

  const etabActuel = etablissements.find(e => e.id === etabSelectionne);

  if (chargement) return <Loader />;

  return (
    <AppLayout role="proprietaire">

      {/* CONTENU */}
      <div style={styles.contenu}>

        {message && (
          <div role="status" style={{
            ...styles.messageBox,
            background: message.startsWith('✅') ? '#ECFDF5' : '#FEF2F2',
            color: message.startsWith('✅') ? '#047857' : '#B91C1C'
          }}>{message.replace(/^(✅|❌|⚠️)\s*/, '')}</div>
        )}

        {/* HEADER */}
        <div style={styles.header}>
          <div>
            <h1 style={styles.headerTitre}>Ventes</h1>
            <p style={styles.headerSousTitre}>
              {etabActuel?.nom || 'Tous'} • {ventesFiltrees.length} vente(s)
            </p>
          </div>
        </div>

        <Tabs
          tabs={[
            { id: 'historique', label: 'Historique', icon: LuReceipt },
            { id: 'caisse', label: 'Nouvelle vente', icon: LuShoppingCart },
          ]}
          value={vue} onChange={setVue}
        />

        {/* SÉLECTEUR ÉTABLISSEMENT */}
        <div style={styles.etabSelector}>
          <div style={styles.etabSelectorTitre}>Établissement</div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {etablissements.map((etab, i) => (
              <div key={i} onClick={() => handleSelectEtab(etab.id)} style={{
                padding: '8px 16px', borderRadius: 10, cursor: 'pointer',
                border: etabSelectionne === etab.id ? '2px solid #EA580C' : '2px solid #E2E8F0',
                background: etabSelectionne === etab.id ? '#FFF7ED' : 'white',
                fontWeight: 700, fontSize: 13
              }}>
                <LuStore aria-hidden style={{ verticalAlign: '-0.125em' }} /> {etab.nom} {etabSelectionne === etab.id && '✓'}
              </div>
            ))}
          </div>
        </div>

        {/* ── VUE HISTORIQUE ── */}
        {vue === 'historique' && (
          <>
            <div style={styles.statsGrid}>
              {[
                { icon: <LuWallet aria-hidden />, label: 'Revenus validés', valeur: fmtF(totalCA), couleur: '#EA580C', bg: '#FFF7ED' },
                { icon: <LuCircleCheck aria-hidden />, label: 'Validées', valeur: ventesFiltrees.filter(v => v.statut === 'validee').length, couleur: '#059669', bg: '#ECFDF5' },
                { icon: <LuBan aria-hidden />, label: 'Annulées', valeur: ventesFiltrees.filter(v => v.statut === 'annulee').length, couleur: '#DC2626', bg: '#FEF2F2' },
                { icon: <LuSmartphone aria-hidden />, label: 'Mobile Money', valeur: ventesFiltrees.filter(v => v.mode_paiement === 'mobile_money').length, couleur: '#7C3AED', bg: '#F5F3FF' },
              ].map((stat, i) => (
                <StatCard key={i} icon={stat.icon} label={stat.label} value={stat.valeur} color={stat.couleur} />
              ))}
            </div>

            <div style={styles.filtres}>
              <input type="text" placeholder="Facture ou serveur..."
                value={recherche} onChange={(e) => setRecherche(e.target.value)}
                style={styles.rechercheInput} />
              <div style={{ display: 'flex', gap: 6 }}>
                {[{ val: 'jour', label: "Auj." }, { val: 'semaine', label: '7j' }, { val: 'mois', label: 'Mois' }, { val: 'tous_temps', label: 'Tout' }].map(f => (
                  <button key={f.val} onClick={() => setFiltrePeriode(f.val)} style={{
                    padding: '7px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 700,
                    background: filtrePeriode === f.val ? 'var(--accent)' : '#F1F5F9',
                    color: filtrePeriode === f.val ? 'white' : '#475569'
                  }}>{f.label}</button>
                ))}
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                {[{ val: 'tous', label: 'Toutes' }, { val: 'validee', label: 'Validées' }, { val: 'annulee', label: 'Annulées' }].map(f => (
                  <button key={f.val} onClick={() => setFiltreStatut(f.val)} style={{
                    padding: '7px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 700,
                    background: filtreStatut === f.val ? '#EA580C' : '#F8FAFC',
                    color: filtreStatut === f.val ? 'white' : '#475569'
                  }}>{f.label}</button>
                ))}
              </div>
            </div>

            <div style={styles.section}>
              {ventesFiltrees.length === 0 ? (
                <div style={styles.vide}>
                  <div style={{ fontSize: 48 }}><LuShoppingCart aria-hidden style={{ verticalAlign: '-0.125em' }} /></div>
                  <p>Aucune vente trouvée</p>
                </div>
              ) : (
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      {['Facture', 'Serveur', 'Établissement', 'Montant', 'Paiement', 'Statut', 'Date', 'Actions'].map((h, i) => (
                        <th key={i} style={styles.th}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {ventesFiltrees.map((v, i) => (
                      <tr key={i} style={{ background: i % 2 === 0 ? '#F8FAFC' : 'white' }}>
                        <td style={styles.td}>
                          <span style={{ fontFamily: 'monospace', color: '#2563EB', fontWeight: 700 }}>
                            {v.numero_facture || '#' + v.id}
                          </span>
                        </td>
                        <td style={styles.td}>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>
                            {(v.serveur_prenom || '') + ' ' + (v.serveur_nom || '')}
                          </div>
                        </td>
                        <td style={styles.td}>
                          <span style={{ color: '#64748B', fontSize: 12 }}>{v.etablissement_nom || '—'}</span>
                        </td>
                        <td style={styles.td}>
                          <span style={{ fontWeight: 700, color: v.statut === 'annulee' ? '#DC2626' : '#EA580C', fontSize: 15 }}>
                            {fmtF(parseInt(v.montant_total))}
                          </span>
                        </td>
                        <td style={styles.td}>
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>{MODES_PAIEMENT[v.mode_paiement]?.icon} {MODES_PAIEMENT[v.mode_paiement]?.label}</span>
                        </td>
                        <td style={styles.td}>
                          <span style={{
                            padding: '4px 10px', borderRadius: 12, fontSize: 12, fontWeight: 700,
                            background: v.statut === 'validee' ? '#ECFDF5' : '#FEF2F2',
                            color: v.statut === 'validee' ? '#059669' : '#DC2626'
                          }}>
                            {v.statut === 'validee' ? 'Validée' : 'Annulée'}
                          </span>
                        </td>
                        <td style={styles.td}>
                          <div style={{ fontSize: 12 }}>{new Date(v.created_at).toLocaleDateString('fr-FR')}</div>
                          <div style={{ color: '#64748B', fontSize: 11 }}>
                            {new Date(v.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                          </div>
                        </td>
                        <td style={styles.td}>
                          <div style={{ display: 'flex', gap: 6 }}>
                            <button onClick={() => setVenteDetail(v)} style={styles.btnVoir} aria-label="Voir le détail" title="Voir le détail"><LuEye aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                            {v.statut === 'validee' && (
                              <button onClick={() => handleAnnuler(v)} style={styles.btnAnnulerBtn} aria-label="Annuler la vente" title="Annuler la vente"><LuBan aria-hidden style={{ verticalAlign: '-0.125em' }} /></button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </>
        )}

        {/* ── VUE CAISSE ── */}
        {vue === 'caisse' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: 20 }}>

            {/* CATALOGUE */}
            <div>
              <div style={{ background: 'white', borderRadius: 12, padding: '16px 20px', marginBottom: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  {[{ id: 'produits', label: 'Produits' }, { id: 'kits', label: 'Kits' }].map(o => (
                    <button key={o.id} onClick={() => setOngletCaisse(o.id)} style={{
                      padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
                      fontWeight: 700, fontSize: 13,
                      background: ongletCaisse === o.id ? '#EA580C' : '#F8FAFC',
                      color: ongletCaisse === o.id ? 'white' : '#475569'
                    }}>{o.label}</button>
                  ))}
                </div>
                <input type="text"
                  placeholder={'Rechercher ' + (ongletCaisse === 'produits' ? 'un produit' : 'un kit') + '...'}
                  value={rechercheArticle} onChange={(e) => setRechercheArticle(e.target.value)}
                  style={{ ...styles.rechercheInput, width: '100%', boxSizing: 'border-box' }} />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
               {articlesFiltres.map((article, i) => (
                  <div key={i} onClick={() => ajouterAuPanier(article, ongletCaisse === 'produits' ? 'produit' : 'kit')}
                    style={{
                      background: 'white', borderRadius: 12, padding: 16, cursor: 'pointer',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center',
                      border: '2px solid transparent', transition: 'all 0.2s'
                    }}
                    onMouseEnter={e => e.currentTarget.style.border = '2px solid #EA580C'}
                    onMouseLeave={e => e.currentTarget.style.border = '2px solid transparent'}
                  >
                    <div style={{ marginBottom: 8 }}>
                      {ongletCaisse === 'produits' && article.image_principale ? (
                        <img
                          src={SERVER_URL + '/uploads/produits/' +
                            article.image_principale.replace(/\\/g, '/').split('/').pop()}
                          alt="produit"
                          style={{ width: 80, height: 80, borderRadius: 10, objectFit: 'cover' }}
                        />
                      ) : (
                        <div style={{
                          width: 80, height: 80, borderRadius: 10, margin: '0 auto',
                          background: ongletCaisse === 'produits' ? '#FFF7ED' : '#F5F3FF',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36
                        }}>
                          {ongletCaisse === 'produits' ? <LuPackage aria-hidden /> : <LuGift aria-hidden />}
                        </div>
                      )}
                    </div>
                    <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}>{article.nom}</div>
                    <div style={{ color: '#EA580C', fontWeight: 700, fontSize: 15 }}>
                      {fmtF(parseInt(article.prix || article.prix_kit))}
                    </div>
                    {ongletCaisse === 'produits' && (
                      <div style={{ color: article.quantite <= article.seuil_alerte ? '#DC2626' : '#059669', fontSize: 11, marginTop: 4 }}>
                        Stock: {article.quantite} {article.unite}
                      </div>
                    )}
                  </div>
                ))}
                {articlesFiltres.length === 0 && (
                  <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 40, color: '#64748B' }}>
                    Aucun article disponible
                  </div>
                )}
              </div>
            </div>

            {/* PANIER */}
            <div style={{ background: 'white', borderRadius: 12, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', height: 'fit-content', position: 'sticky', top: 24 }}>
              <h3 style={{ margin: '0 0 16px', color: '#0F172A' }}><LuReceipt aria-hidden style={{ verticalAlign: '-0.125em' }} /> Panier ({panier.length})</h3>

              {panier.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 30, color: '#64748B' }}>
                  <div style={{ fontSize: 40 }}><LuShoppingCart aria-hidden style={{ verticalAlign: '-0.125em' }} /></div>
                  <p style={{ fontSize: 13 }}>Cliquez sur un article pour l'ajouter</p>
                </div>
              ) : (
                <>
                  <div style={{ maxHeight: 280, overflowY: 'auto', marginBottom: 16 }}>
                    {panier.map((item, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', borderBottom: '1px solid #F1F5F9' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 700, fontSize: 13 }}>{item.nom}</div>
                          <div style={{ color: '#EA580C', fontSize: 12 }}>
                            {fmtF(parseInt(item.prix))}
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <button onClick={() => modifierQte(item.id, item.type, -1)}
                            style={styles.btnQte}>−</button>
                          <span style={{ fontWeight: 700, fontSize: 14, minWidth: 20, textAlign: 'center' }}>
                            {item.quantite}
                          </span>
                          <button onClick={() => modifierQte(item.id, item.type, 1)}
                            style={styles.btnQte}>+</button>
                          <button onClick={() => retirerDuPanier(item.id, item.type)}
                            style={{ ...styles.btnQte, background: '#FEF2F2', color: '#DC2626' }}>✕</button>
                        </div>
                        <div style={{ fontWeight: 700, fontSize: 13, color: '#2563EB', minWidth: 60, textAlign: 'right' }}>
                          {fmtF((parseInt(item.prix) * item.quantite))}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div style={{ background: '#FFF7ED', borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: 18 }}>
                      <span>Total</span>
                      <span style={{ color: '#EA580C' }}>{fmtF(totalPanier)}</span>
                    </div>
                  </div>

                  <div style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8, color: '#334155' }}><LuCreditCard aria-hidden style={{ verticalAlign: '-0.125em' }} /> Mode de paiement</div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {Object.entries(MODES_PAIEMENT).map(([key, val]) => (
                        <button key={key} onClick={() => setModePaiement(key)} style={{
                          flex: 1, padding: '8px 4px', borderRadius: 8, border: 'none',
                          cursor: 'pointer', fontSize: 11, fontWeight: 700,
                          background: modePaiement === key ? 'var(--accent)' : '#F1F5F9',
                          color: modePaiement === key ? 'white' : '#475569'
                        }}>{val.icon} {val.label}</button>
                      ))}
                    </div>
                  </div>

                  <input type="text" value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Note (optionnel)..."
                    style={{ ...styles.rechercheInput, width: '100%', boxSizing: 'border-box', marginBottom: 12 }} />

                  <button onClick={validerVente} disabled={chargementVente} style={{
                    width: '100%', padding: '14px', border: 'none', borderRadius: 10,
                    background: chargementVente ? '#ccc' : 'var(--accent)',
                    color: 'white', fontWeight: 700, fontSize: 16, cursor: chargementVente ? 'not-allowed' : 'pointer'
                  }}>
                    {chargementVente ? 'En cours...' : 'Valider ' + fmtF(totalPanier)}
                  </button>

                  <button onClick={() => setPanier([])} style={{
                    width: '100%', marginTop: 8, padding: '10px', border: '1px solid #E2E8F0',
                    borderRadius: 10, background: 'white', color: '#DC2626',
                    cursor: 'pointer', fontSize: 13
                  }}><LuTrash2 aria-hidden style={{ verticalAlign: '-0.125em' }} /> Vider le panier</button>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      {/* MODAL DÉTAIL VENTE */}
      {venteDetail && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, color: '#0F172A' }}>
                <LuReceipt aria-hidden style={{ verticalAlign: '-0.125em' }} /> {venteDetail.numero_facture || '#' + venteDetail.id}
              </h3>
              <button onClick={() => setVenteDetail(null)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
              {[
                { label: 'Serveur', valeur: (venteDetail.serveur_prenom || '') + ' ' + (venteDetail.serveur_nom || '') },
                { label: 'Établissement', valeur: venteDetail.etablissement_nom || '—' },
                { label: 'Paiement', valeur: MODES_PAIEMENT[venteDetail.mode_paiement]?.label },
                { label: 'Statut', valeur: venteDetail.statut === 'validee' ? 'Validée' : 'Annulée' },
                { label: 'Date', valeur: new Date(venteDetail.created_at).toLocaleString('fr-FR') },
              ].map((info, i) => (
                <div key={i} style={{ background: '#F8FAFC', borderRadius: 8, padding: '8px 12px' }}>
                  <div style={{ color: '#64748B', fontSize: 11 }}>{info.label}</div>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>{info.valeur}</div>
                </div>
              ))}
            </div>

            {venteDetail.motif_annulation && (
              <div style={{ background: '#FEF2F2', borderRadius: 8, padding: '10px 14px', marginBottom: 12 }}>
                <div style={{ color: '#DC2626', fontWeight: 700, fontSize: 13 }}>
                  <LuBan aria-hidden style={{ verticalAlign: '-0.125em' }} /> Motif : {venteDetail.motif_annulation}
                </div>
              </div>
            )}

            <div style={{ borderTop: '2px solid #F1F5F9', paddingTop: 12, marginBottom: 12 }}>
              {(venteDetail.details || []).map((d, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #F1F5F9', fontSize: 13 }}>
                  <span>{d.produit_nom || d.kit_nom || '—'} × {d.quantite}</span>
                  <span style={{ fontWeight: 700, color: '#2563EB' }}>{fmtF(parseInt(d.sous_total))}</span>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', background: '#FFF7ED', borderRadius: 10, padding: '12px 16px', fontWeight: 700, fontSize: 18, marginBottom: 16 }}>
              <span>Total</span>
              <span style={{ color: '#EA580C' }}>{fmtF(parseInt(venteDetail.montant_total))}</span>
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setVenteDetail(null)} style={styles.btnFermer}>Fermer</button>
              {venteDetail.statut === 'validee' && (
                <button onClick={() => handleAnnuler(venteDetail)} style={styles.btnAnnulerModal}>
                  <LuBan aria-hidden style={{ verticalAlign: '-0.125em' }} /> Annuler cette vente
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </AppLayout>
  );
}

const styles = {
  chargement: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: 24, color: '#475569' },
  contenu: { ...S.contenu, flex: 1 },
  messageBox: { ...S.messageBox, marginBottom: 16 },
  header: S.header,
  headerTitre: S.headerTitre,
  headerSousTitre: S.headerSousTitre,
  etabSelector: { ...S.etabSelector, marginBottom: 20 },
  etabSelectorTitre: { ...S.etabSelectorTitre, marginBottom: 10 },
  statsGrid: { ...S.statsGrid, marginBottom: 20 },
  statCard: S.statCard,
  filtres: { ...S.filtres, marginBottom: 16 },
  rechercheInput: { ...S.rechercheInput },
  section: S.section,
  vide: S.vide,
  table: { ...S.table, width: '100%' },
  tableHeader: S.tableHeader,
  th: S.th,
  td: S.td,
  btnVoir: S.btnVoir,
  btnAnnulerBtn: S.btnAnnulerBtn,
  btnQte: { width: 28, height: 28, borderRadius: 6, border: 'none', background: '#F8FAFC', cursor: 'pointer', fontWeight: 700, fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  overlay: S.overlay,
  modal: { ...S.modal, width: 'min(500px, 100%)' },
  btnFermer: { ...S.btnFermer, flex: 1 },
  btnAnnulerModal: { ...S.btnAnnulerModal, flex: 1 },
};